// import { LuScreenShare } from "react-icons/lu";
import footer from "../Styles/Footer.module.scss";
import { Col, Container, Form, Row} from "react-bootstrap";
const Footer = () => {
  const currentDate = new Date();
  const year = currentDate.getUTCFullYear();
  return (
    <div className={footer.footer}>
      <Container fluid>
        <Row>
          <Form.Group as={Col} md={12}>
            <div className={footer.innerFooter}>
              <p className="mb-1">
                <i className="fas fa-copyright" /> {year} CopyRight | Galaxbiotech®
              </p>
              <div className="hstack gap-2">
                <p className="m-0">V2.0.0</p>
              </div>
            </div>
          </Form.Group>
        </Row>
      </Container>
    </div>
  );
};

export default Footer;
